import Dream from '../dream';

/**
 * Create the action
 */

const { thunk, request, success, error } = Dream.store((data, fetch) => {
  if (data.copyDream === true) {
    return fetch.post('/dreams/copy-dream', data);
  }

  // Prepare request
  const formData = new FormData();

  Object.keys(data).forEach(function (key) {
    if (key === 'file') {
      if (data?.[key]?.constructor === File) {
        formData.append(key, data?.[key]);
      }
    } else if (key === 'activities' || key === 'skills') {
      formData.append(key, JSON.stringify(data?.[key]));
    } else {
      formData.append(key, data?.[key]);
    }
  });

  return fetch.post('/dreams/dream', formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
